import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Loading from 'components/Loading/index';
import Util from 'utility';
import api from 'api';

import { 
    closeModal,
    showMessage,
    loadGlobals,
    loginUser,
} from 'actions/index';

const mapStateToProps = state => {
    return { data: state };
}

const mapDispatchToProps = dispatch => {
    return {
        closeModal: data => dispatch(closeModal(data)),
        showMessage: data => dispatch(showMessage(data)),
        loadGlobals: data => dispatch(loadGlobals(data)),
        loginUser: data => dispatch(loginUser(data)),
    };
};


class PanelDeleteGroup extends Component { 
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.id,
            title: this.props.title
        };    

        this.doDelete = this.doDelete.bind(this);
    }

    doDelete() {
        api('clients/groups/delete', { post: true, data: { id: this.state.id }}).then((res) =>{
            this.props.onDone();
        });
    }

    render() {
        const { client } = this.state;
        const { globals } = this.props.data;

        return (
            <React.Fragment>
            <div className="filters">
                <p>Opravdu chcete smazat tým?</p>
                <p><b>{this.props.title}</b></p>
                <p><button onClick={this.doDelete}>Ano, smazat</button></p>
            </div>
            </React.Fragment>            
        );            
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PanelDeleteGroup));
